<template>
	<div class="border rounded-sm bg-white">
		<table class="w-full text-left">
			<thead class="border-b">
				<tr>
					<th class="px-3 py-2 font-medium">Berichtsoort</th>
					<th class="px-3 py-2 font-medium text-end">Datum</th>
				</tr>
			</thead>
			<tbody>
				<LoanApplicationMessageRow
					v-for="message in sortedMessages"
					:key="sortedMessages.indexOf(message)"
					:message
				/>
			</tbody>
		</table>
		<div
			v-if="sortedMessages.length === 0"
			class="flex items-center justify-center h-44 gap-2 text-[var(--text-muted)]"
		>
			<span class="inline-block ht-icon size-6"> inbox </span>
			Nog geen berichten in deze offerteaanvraag
		</div>
	</div>
</template>

<script lang="ts" setup>
import { api } from "@/loanLinkApi";
import type { Ref } from "vue";
import { computed, ref } from "vue";
import type { LoanApplicationMessage } from "@/generatedApi";

interface Props {
	dossierId: string;
	loanApplicationId: string;
}
const props = defineProps<Props>();

const messages: Ref<LoanApplicationMessage[]> = ref([]);
const apiError = ref<Error | null>(null);

await api.loanApplication
	.getApplicationMessages(props.loanApplicationId)
	.then((res) => (messages.value = res.data?.messages ?? []))
	.catch((error) => (apiError.value = error));

const sortedMessages = computed(() =>
	messages.value.toSorted((a, b) => a.sentAt.localeCompare(b.sentAt)),
);
</script>
